import React from 'react';
import PropTypes from 'prop-types';

const Globe = ({ fill, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.52"
    height="15.52"
    viewBox="0 0 15.52 15.52"
    className={className}
  >
    <path
      d="M9.075,2.476a7.793,7.793,0,0,0,7.756-7.756,7.8,7.8,0,0,0-7.764-7.764A7.79,7.79,0,0,0,1.311-5.281,7.794,7.794,0,0,0,9.075,2.476ZM4.607-9.6A6.3,6.3,0,0,1,7.2-11.221a5.917,5.917,0,0,0-1.333,2.19A4.792,4.792,0,0,1,4.607-9.6Zm6.335-1.611A6.241,6.241,0,0,1,13.535-9.6a5.107,5.107,0,0,1-1.252.579A5.867,5.867,0,0,0,10.942-11.213ZM7.017-8.76A3.889,3.889,0,0,1,8.5-10.818v2.212A11.467,11.467,0,0,1,7.017-8.76Zm2.629-2.058A3.889,3.889,0,0,1,11.125-8.76a11.467,11.467,0,0,1-1.479.154ZM2.878-5.859A6.108,6.108,0,0,1,3.9-8.73a5.471,5.471,0,0,0,1.633.784,11.484,11.484,0,0,0-.286,2.087Zm10.012,0A11.484,11.484,0,0,0,12.6-7.947a5.385,5.385,0,0,0,1.633-.784,6.226,6.226,0,0,1,1.033,2.871Zm-6.467,0a10.676,10.676,0,0,1,.256-1.8,11.887,11.887,0,0,0,1.816.2v1.6Zm3.223,0v-1.6a11.786,11.786,0,0,0,1.816-.2,10.667,10.667,0,0,1,.264,1.8ZM2.871-4.717h2.38A11.094,11.094,0,0,0,5.544-2.6a5.6,5.6,0,0,0-1.626.776A6.217,6.217,0,0,1,2.871-4.717Zm3.545,0H8.5v1.633a12.641,12.641,0,0,0-1.809.205A10.483,10.483,0,0,1,6.416-4.717Zm3.23,1.633V-4.717h2.08a10.483,10.483,0,0,1-.271,1.838A12.521,12.521,0,0,0,9.646-3.083ZM12.6-2.6a11.107,11.107,0,0,0,.286-2.117h2.38a6.208,6.208,0,0,1-1.04,2.893A5.792,5.792,0,0,0,12.6-2.6Zm-5.581.813A13.01,13.01,0,0,1,8.5-1.934V.256A3.905,3.905,0,0,1,7.024-1.787Zm2.622-.146a12.842,12.842,0,0,1,1.472.146A3.9,3.9,0,0,1,9.646.256ZM4.629-.952a4.988,4.988,0,0,1,1.238-.564A5.869,5.869,0,0,0,7.192.645,6.231,6.231,0,0,1,4.629-.952Zm7.646-.564a5.047,5.047,0,0,1,1.245.564A6.3,6.3,0,0,1,10.95.645,5.869,5.869,0,0,0,12.275-1.516Z"
      transform="translate(-1.311 13.044)"
      fill={fill}
    />
  </svg>
);

Globe.propTypes = {
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Globe;
